export default __webpack_public_path__ + "static/media/O-022.542dca3b.png";